module.exports = __webpack_public_path__ + "static/media/7C.276b21c0.svg";